import _ from 'lodash'
import recallServices from '../../../../../../services/supplier/supplier-recall'
import supplierAppServices from '../../../../../../services/supplier/application'
import VueTagsInput from '@johmun/vue-tags-input'
import ViewModal from '../../../../../../components/part/shared/PreviewViewModal'
import moment from 'moment-timezone'
import ActionType from './../../../../../../components/part/provider/PaperResponseActionType'
import { PAPER_RESPONSE_TYPE, PAPER_RESPONSE_STATUS, COMMUNICATION_TYPE } from '../../../../../../misc/commons'
import NonVerifiedUserModal from './NonVerifiedUserModal'
import { formatHistoryContent } from '../../../../../../utils/history-content'
import {
    getStatusSelectOptions,
    isViewOnlyStatus,
    validateEditStatusTransition,
} from '../../../../../../utils/paper-response-status'
export default {
    components: {
        VueTagsInput,
        ActionType,
        ViewModal,
        NonVerifiedUserModal
    },
    props: {
        totalItem: { type: [], default: null }
    },
    data() {
        return {
            communicationType: { type: String, default: '' },
            communicationId: this.$parent.communicationId,
            organizationId: null,
            actions: null,
            isExpanded: false,
            cnt: 1,
            editMode: true,
            item: {
                idn: null,
                providerName: null,
                location: null,
                responder: null,
                supplierActions: null,
                notes: null,
                responseDate: new Date(),
                responseType: 'Paper',
                paperresponseid: null,
                emailAddress: null,
                emailRadioOption: null,
                status: 'Not Acknowledged',
            },
            valueTag: [],
            tags: [],
            tag: '',
            locationObj: null,
            selectedLocations: [],
            value: [],
            locName: '',
            valueTagS: [],
            tagsS: [],
            tagS: '',
            providerSearchValue: '',
            valueS: [],
            isDisabled: false,
            isDisabledLocation: false,
            notification_date: null,
            title: 'New Response',
            selectedResponseType: 'Paper',
            filesUpload: [],
            uploadedFiles: [],
            NotificationfilesUpload: [],
            thumbnailIndex: -1,
            viewModalKey: 0,
            sup: 'sup',
            IsVal: false,
            disabledDates: {
                from: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                to: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
            },
            autocompleteItemslst: [],
            providerDetails: [],
            autocompleteItemsLoc: [],
            autocompleteItemsLocByIDN: [],
            autocompleteItemsEditLocByIDN: [],
            RESPONSE_TYPE: PAPER_RESPONSE_TYPE,
            STATUS_OPTIONS: PAPER_RESPONSE_STATUS,
            locationList: [],
            locationListFiltered: [],
            formType: '',
            canSelectCentralIntake: true,
            isLocationLockedByCoveredStatus: false,
            histories: [],
            communicationTypeForRecall: COMMUNICATION_TYPE.RECALL,
            activeTab: 0,
            supplierRecallId: '',
            originalStatus: null,
            selectedLocationResponseStatus: null,
            originalResponseDateForSave: null,
            responseDateUserEdited: false,
            supplierActionResponseAndStatus: null,
            hasAddedActionResponse: false,
            initialActionResponses: [],
            responseTypeObj: {
                'COVERED': 'Notisphere',
                'EMAILED': 'Emailed'
            },
        }
    },
    computed: {
        isRequired() {
            return true
        },
        statusSelectOptions() {
            if (this.formType === 'EDIT' && this.originalStatus) {
                return getStatusSelectOptions(this.STATUS_OPTIONS, this.originalStatus)
            }
            if (this.formType === 'INSERT' && this.selectedLocationResponseStatus) {
                return getStatusSelectOptions(this.STATUS_OPTIONS, this.selectedLocationResponseStatus)
            }
            return this.STATUS_OPTIONS
        },
        filteredItems() {
            this.autocompleteItemsLoc = []
            for (let i = 0; i < this.autocompleteItemsLocByIDN.length; i++) {
                if (this.autocompleteItemsLocByIDN[i].idn == this.tagS) {
                    this.autocompleteItemsLoc.push(this.autocompleteItemsLocByIDN[i].location_name)
                }
            }
            return this.autocompleteItemsLoc.filter(i => {
                if (i != null)
                    return i.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
            })
        },
        filteredSupItems() {
            return this.autocompleteItemslst.map(provider => provider.idn_sitename || provider.idn)
        },
        canEditLocationsInEditMode() {
            if (this.formType !== 'EDIT') {
                return false
            }

            const selectedProvider = this.autocompleteItemslst.find(provider => provider.idn == this.tagS)
            const providerCoveredStatus = String(selectedProvider?.coveredstatus || selectedProvider?.coveredStatus || '').toUpperCase()

            return providerCoveredStatus === 'NON_COVERED' || providerCoveredStatus === 'NON-COVERED'
        },
    },
    watch: {
        tagS(newValue) {
            if (this.formType !== 'INSERT' && this.formType !== 'EDIT') {
                return
            }

            if (!newValue) {
                this.organizationId = null
                this.item.emailAddress = null
                this.item.emailRadioOption = null
                this.locationObj = []
                this.locationListFiltered = []
                this.isLocationLockedByCoveredStatus = false
                return
            }

            this.applyProviderLocationSelectionRules(newValue)
            this.updateEmailDefaultsByProvider(newValue)
        },
        locationObj() {
            if (this.formType !== 'INSERT' && this.formType !== 'EDIT') {
                return
            }

            if (!this.tagS) {
                return
            }

            this.updateEmailDefaultsByProvider(this.getSelectedProviderIDN())
        },
        'item.emailRadioOption'(newVal) {
            if (!this.canSelectCentralIntake && newVal === 'central-intake') {
                this.item.emailRadioOption = 'non-verified'
                return
            }
            const selectedLocationId = Array.isArray(this.locationObj)
                ? (this.locationObj.length > 0 ? this.locationObj[0] : null)
                : this.locationObj
            const selectedLocation = selectedLocationId
                ? this.locationList.find(x => x.value == selectedLocationId)
                : null
            if (selectedLocation && selectedLocation.coveredStatus === 'EMAILED' && newVal === 'central-intake') {
                this.GetCentralizedIntakeById()
            }
        },
    },
    mounted() {
        this.fetchProviderNameList()
        this.totalItem.forEach((action) => {
            action.location_name.split(',').forEach(x => {
                this.selectedLocations.push(x)  //this.valueTag.push(x)
            })
        })
    },
    methods: {
        formatHistoryContent,
        getRecallActions(formData) {
            recallServices.getRecallActionsForPaperResponse(formData).then(resp => {
                if (!resp.error) {
                    var actions = []
                    resp.data.d.forEach((action) => {
                        if (action.isCustomActionType == false) {
                            actions.push(action)
                        }
                        else {
                            let clidlActions = resp.data.d.filter(x => x.baseActionId == action.id)
                            if (clidlActions.length > 0) {
                                actions.push(action)
                            }
                        }

                    })
                    let baseactions = actions.filter(x => x.baseActionId == 0)
                    baseactions.forEach((action) => {
                        let clidlActions = actions.filter(x => x.baseActionId == action.id)
                        clidlActions.forEach((child) => {
                            child.description = child.description.replace(action.description + ' - ', '')
                        })

                    })
                    const previousActions = Array.isArray(this.actions) ? this.actions : []
                    previousActions.forEach(function (action) {
                        if (action.isExpanded) {
                            for (let i = 0; i < actions.length; i++) {
                                if (actions[i].id == action.id) {
                                    actions[i].isExpanded = action.isExpanded
                                }
                                if (actions[i].baseActionId == action.id) {
                                    actions[i].show = action.isExpanded
                                }
                            }
                        }
                    })
                    for (let i = 0; i < actions.length; i++) {
                        let List = []
                        let len = Array.isArray(actions[i].actionValues) ? actions[i].actionValues.length : 0
                        let act = actions[i]
                        actions[i].childactioncount = actions.filter(s => s.baseActionId != 0 && s.baseActionId == actions[i].id).length
                        if (actions[i].action_type == 'MultipleChoice') {
                            for (let j = 0; j < len; j++) {
                                List.push({
                                    value: this.cnt,
                                    text: act.actionValues[j].value,
                                })
                                if (!act.isAllowOnlyOne) {
                                    const multiChoiceValues = Array.isArray(act?.response_data?.valueMultiChoice)
                                        ? act.response_data.valueMultiChoice
                                        : []
                                    multiChoiceValues.forEach((element) => {
                                        if (element.valueMultiChoice == act.actionValues[j].value) {
                                            if (act.multiSelectedValues == null) {
                                                act.multiSelectedValues = []
                                            }
                                            act.multiSelectedValues.push(this.cnt)
                                        }
                                    })
                                } else {
                                    if (act.response_data.valueMultiChoice == undefined) {
                                        if (act.response_data.valueSingleChoice != undefined) {
                                            if (act.response_data.valueSingleChoice == act.actionValues[j].value) {
                                                act.singleSelectedValues = this.cnt
                                            }
                                        }
                                    }
                                    else {
                                        if (act.response_data.valueMultiChoice.length > 0) {
                                            if (act.response_data.valueMultiChoice[0].valueMultiChoice == act.actionValues[j].value) {
                                                act.singleSelectedValues = this.cnt
                                            }
                                        }
                                    }
                                }
                                this.cnt++
                            }
                        }
                        actions[i].actionValues = []

                        actions[i].actionValues = List
                    }
                    this.actions = []
                    this.actions = actions
                    this.applySupplierDataToActions()
                }
            })
        },
        expandMoreLess(action) {
            if (action.isCustomActionType) {
                action.isExpanded = action.isCustomActionType ? !action.isExpanded : action.isExpanded
            }
        },
        GetNotifiedDate() {
            recallServices.getRecallById(this.communicationId).then(resp => {
                if (!resp.error) {

                    this.disabledDates.to = new Date(new Date(resp.data.d.communicationDate.split(' ')[0]).getFullYear(), new Date(resp.data.d.communicationDate.split(' ')[0]).getMonth(), (new Date(resp.data.d.communicationDate.split(' ')[0]).getDate()))
                }
            })
        },
        GetCentralizedIntakeById() {
            if (!this.organizationId) {
                return
            }
            if (this.formType === 'EDIT' && this.item.emailRadioOption != null && this.item.emailRadioOption !== 'central-intake') {
                const selectedLocationId = Array.isArray(this.locationObj)
                    ? (this.locationObj.length > 0 ? this.locationObj[0] : null)
                    : this.locationObj
                const selectedLocation = selectedLocationId
                    ? this.locationList.find(x => x.value == selectedLocationId)
                    : null
                if (!selectedLocation || selectedLocation.coveredStatus !== 'Emailed') {
                    return
                }
            }

            supplierAppServices.getCentralizedIntakeById(this.organizationId).then(resp => {
                if (!resp.error) {
                    if (resp.data.d.isSettingEnabled === true) {
                        this.canSelectCentralIntake = true
                        this.item.emailAddress = resp.data.d.centralizedEmail
                        this.item.emailRadioOption = 'central-intake'
                    }
                    else if (resp.data.d.isSettingEnabled === false) {
                        this.canSelectCentralIntake = false
                        this.item.emailAddress = null
                        this.item.emailRadioOption = 'non-verified'
                    }
                    else {
                        this.canSelectCentralIntake = true
                        this.item.emailRadioOption = resp.data.d.isSettingEnabled || null
                    }
                }
            })
        },
        updateEmailDefaultsByProvider(providerName) {
            const selectedLocationId = Array.isArray(this.locationObj)
                ? (this.locationObj.length > 0 ? this.locationObj[0] : null)
                : this.locationObj
            var selectedLocation = selectedLocationId
                ? this.locationList.find(x => x.value == selectedLocationId && (!providerName || (x.idn + '-' + x.siteName) == providerName))
                : null
            if (!selectedLocation && providerName) {
                selectedLocation = this.locationList.find(x => x.value == selectedLocationId)
            }
            this.organizationId = selectedLocation
                ? (selectedLocation.organizationId || selectedLocation.organization_id || selectedLocation.OrganizationId || selectedLocation.providerOrgId || null)
                : null
            if (!this.organizationId) {
                this.canSelectCentralIntake = true
                this.item.emailAddress = null
                if (this.formType !== 'EDIT' || this.item.emailRadioOption == null) {
                    this.item.emailRadioOption = null
                }
                return
            }

            this.GetCentralizedIntakeById()
        },
        openNonVerifiedUserModal() {
            this.$refs.nonVerifiedUserModal.editingEmailUserId = null
            this.$refs.nonVerifiedUserModal.editingEmailValue = ''
            this.$refs.nonVerifiedUserModal.forceRerenderInsert(this.organizationId)
        },
        onNonVerifiedUserSelected(user) {
            //this.item.emailAddress = user.email
        },
        async updateCentralizedSettingIfNeeded() {
            let centralizedEmail = this.item.emailAddress
            if ((!centralizedEmail || !String(centralizedEmail).trim()) && this.item.emailRadioOption === 'central-intake' && this.organizationId) {
                const intakeResp = await supplierAppServices.getCentralizedIntakeById(this.organizationId)
                if (!intakeResp.error) {
                    centralizedEmail = intakeResp.data.d?.centralizedEmail
                }
            }

            if (this.item.emailRadioOption === 'central-intake' && this.organizationId && centralizedEmail) {
                await recallServices.updateCentralizedSetting({
                    OrganizationId: this.organizationId,
                    AllowCentralizedIntake: true,
                    CentralizedEmail: centralizedEmail
                })
            }
        },
        forceRerenderInsert(list) {
            this.formType = 'INSERT'
            this.communicationType = list.communicationType
            this.fetchLocationList()
            this.GetNotifiedDate()
            this.paperresponseid = 0
            this.isDisabled = false
            this.isDisabledLocation = false
            this.editMode = true
            this.originalStatus = null
            this.originalResponseDateForSave = null
            this.responseDateUserEdited = false
            this.organizationId = null
            this.locationObj = []
            this.providerSearchValue = ''
            this.tagS = ''
            this.item.emailAddress = null
            this.item.emailRadioOption = null
            this.item.status = 'Not Acknowledged'
            this.isLocationLockedByCoveredStatus = false
            this.selectedLocationResponseStatus = null
            this.supplierActionResponseAndStatus = null
            this.hasAddedActionResponse = false
            this.initialActionResponses = []
            this.histories = []
            this.activeTab = 0
            this.$refs.modal.show()
        },
        getSupplierActions(formData) {
            recallServices.getPaperResponseActions(formData).then(resp => {
                if (!resp.error) {
                    var actions = []
                    resp.data.d.forEach((action) => {
                        if (action.isCustomActionType == false) {
                            actions.push(action)
                        }
                        else {
                            let clidlActions = resp.data.d.filter(x => x.baseActionId == action.id)
                            if (clidlActions.length > 0) {
                                actions.push(action)
                            }
                        }

                    })
                    this.actions = actions
                    let baseactions = this.actions.filter(x => x.baseActionId == 0)
                    baseactions.forEach((action) => {
                        let clidlActions = this.actions.filter(x => x.baseActionId == action.id)
                        clidlActions.forEach((child) => {
                            child.description = child.description.replace(action.description + ' - ', '')
                        })

                    })
                    for (let i = 0; i < this.actions.length; i++) {
                        let List = []
                        let len = Array.isArray(this.actions[i].actionValues) ? this.actions[i].actionValues.length : 0
                        let act = this.actions[i]
                        this.actions[i].childactioncount = this.actions.filter(s => s.baseActionId != 0 && s.baseActionId == this.actions[i].id).length
                        if (this.actions[i].action_type == 'MultipleChoice') {
                            for (let j = 0; j < len; j++) {
                                List.push({
                                    value: this.cnt,
                                    text: act.actionValues[j].value,
                                })
                                if (!act.isAllowOnlyOne) {
                                    act.response_data.valueMultiChoice.forEach((element) => {
                                        if (element.valueMultiChoice == act.actionValues[j].value) {
                                            if (act.multiSelectedValues == null) {
                                                act.multiSelectedValues = []
                                            }
                                            act.multiSelectedValues.push(this.cnt)
                                        }
                                    })
                                } else {
                                    if (act.response_data.valueMultiChoice == undefined) {
                                        if (act.response_data.valueSingleChoice != undefined) {
                                            if (act.response_data.valueSingleChoice == act.actionValues[j].value) {
                                                act.singleSelectedValues = this.cnt
                                            }
                                        }
                                    }
                                    else {
                                        if (act.response_data.valueMultiChoice.length > 0) {
                                            if (act.response_data.valueMultiChoice[0].valueMultiChoice == act.actionValues[j].value) {
                                                act.singleSelectedValues = this.cnt
                                            }
                                        }
                                    }
                                }
                                this.cnt++
                            }
                            this.actions[i].actionValues = []
                            this.actions[i].actionValues = List
                        }
                    }
                    if (this.formType == 'EDIT') {
                        this.setInitialActionResponses()
                    }
                }
            })
        },
        forceRerenderEdit(list) {
            this.responseDateEdit()
            this.fetchDocumentsById(parseInt(list.paper_response_id))
            this.responseDateEdit()
            this.GetNotifiedDate()
            this.item.emailRadioOption = list.emailRadioOption
            this.originalStatus = list.status
            this.initialActionResponses = []
            this.formType = 'EDIT'
            this.title = 'Update Response'
            this.communicationType = list.communicationType
            this.item.notes = list.notes
            this.item.paperresponseid = parseInt(list.paper_response_id)
            this.item.responder = list.responder
            this.item.responseType = list.response_type
            this.item.providerName = list.idn
            this.item.responseDate = this.parseResponseDate(list.response_date)
            this.originalResponseDateForSave = this.toApiResponseDate(list.response_date)
            this.responseDateUserEdited = false
            this.item.emailAddress = list.emailAddress
            this.item.status = list.status
            this.locName = list.locationId + '-'+ list.location_name
            this.selectedResponseType = list.response_type
            this.valueTag = []
            this.value = []
            this.locationObj = []
            this.locationListFiltered = []
            list.location_name.split(',').forEach(x => {
                this.valueTag.push((x || '').trim())
            })
            list.location_name.split(',').forEach(x => {
                this.value.push((x || '').trim())
            })
            this.tagS = list.idn
            this.fetchLocationListForEdit()
            if (this.providerDetails.length > 0) {
                this.updateEmailDefaultsByProvider(this.getSelectedProviderIDN())
            }
            else {
                this.fetchProviderNameList().then(() => {
                    this.updateEmailDefaultsByProvider(this.getSelectedProviderIDN())
                })
            }
            this.getSupplierActions(parseInt(list.paper_response_id))
            this.valueS.push(list.idn)
            if (isViewOnlyStatus(list.status)) {
                this.editMode = false
                this.isDisabled = true
            } else {
                this.editMode = true
                this.isDisabled = false
            }
            this.isDisabledLocation = true
            this.supplierRecallId = list.communicationUID || ''
            this.activeTab = 0
            this.getProviderResponseHistory(parseInt(list.paper_response_id))
            this.$refs.modal.show()
        },
        forceRerenderView(list) {
            this.fetchDocumentsById(parseInt(list.paper_response_id))
            this.getSupplierActions(parseInt(list.paper_response_id))
            this.title = 'View Response'
            this.item.paperresponseid = parseInt(list.paper_response_id)
            this.editMode = false
            this.formType = 'VIEW'
            this.originalStatus = list.status
            this.isDisabled = true
            this.isDisabledLocation = true
            this.tagS = list.idn
            this.valueTag = []
            this.locationObj = null
            list.location_name.split(',').forEach(x => {
                this.valueTag.push((x || '').trim())
            })
            this.item.notes = list.notes
            this.item.emailAddress = list.emailAddress
            this.item.emailRadioOption = list.emailRadioOption || 'central-intake'
            this.item.status = list.status
            this.selectedResponseType = list.response_type
            this.item.responder = list.responder
            this.item.responseType = list.response_type
            this.item.providerName = list.idn
            this.item.responseDate = this.parseResponseDate(list.response_date)
            this.locName = list.location_name
            this.fetchLocationListForEdit().then(() => {
                if ((!this.item.emailAddress || !String(this.item.emailAddress).trim()) && this.item.emailRadioOption === 'central-intake') {
                    this.updateEmailDefaultsByProvider(this.getSelectedProviderIDN())
                }
            })
            this.supplierRecallId = list.communicationUID || ''
            this.activeTab = 0
            this.getProviderResponseHistory(parseInt(list.paper_response_id))
            this.$refs.modal.show()
        },
        fetchDocumentsById(id) {
            recallServices.getDocForPaperResponse(id).then((res) => {
                if (!res.error) {
                    var uploadedFiles = res.data.d
                    this.filesUploadOriginal = []
                    for (let i = 0; i < uploadedFiles.length; i++) {
                        this.filesUpload.push({
                            extension: uploadedFiles[i].extension,
                            name: uploadedFiles[i].filename,
                            type: uploadedFiles[i].mimetype,
                            size: uploadedFiles[i].fileSize,
                            signed_url: uploadedFiles[i].signed_url,
                            file_id: uploadedFiles[i].file_id,
                            paper_response_id: uploadedFiles[i].paper_response_id,
                            path: uploadedFiles[i].path,
                        })
                        this.filesUploadOriginal.push({
                            extension: uploadedFiles[i].extension,
                            name: uploadedFiles[i].filename,
                            type: uploadedFiles[i].mimetype,
                            size: uploadedFiles[i].fileSize,
                            signed_url: uploadedFiles[i].signed_url,
                            file_id: uploadedFiles[i].file_id,
                            paper_response_id: uploadedFiles[i].paper_response_id,
                            path: uploadedFiles[i].path,
                        })
                    }
                }
            })
        },
        async download(dataurl) {
            this.ViewClick(dataurl)
        },
        ViewClick(val) {
            let itemVal = {
                extension: val.extension,
                filename: val.name,
                signed_url: val.signed_url,
                signed_url_review: val.signed_url_review,
                fileSize: val.size,
                mimetype: val.type
            }
            this.viewModalKey += 1
            this.$nextTick(() => {
                this.$refs.viewModal.forceRerenderInsert(itemVal)
            })
        },
        addCheck(val) {
            const selectedLocationId = Array.isArray(val)
                ? (val.length > 0 ? val[0] : null)
                : val
            const locationObj = this.locationList.find(x => x.value == selectedLocationId)
            let formData = new FormData()
            formData.append('communicationId', this.$parent.communicationId)
            if (selectedLocationId) {
                this.supplierActionResponseAndStatus = null
                formData.append('locationsid', selectedLocationId)
                this.getRecallActions(formData)
                if (locationObj && (locationObj.coveredStatus === 'EMAILED' || locationObj.coveredStatus === 'COVERED')) {
                    this.selectedResponseType = this.responseTypeObj[locationObj?.coveredStatus] || 'Paper'
                    this.getSupplierActionResponseAndStatus(locationObj.providerOrgId, selectedLocationId)
                } else {
                    this.selectedLocationResponseStatus = null
                    this.item.status = 'Not Acknowledged'
                }
            }
            else {
                this.actions = null
                this.selectedLocationResponseStatus = null
                this.item.status = 'Not Acknowledged'
            }
        },
        addSupCheck(displayValue) {
            this.providerSearchValue = displayValue || ''

            if (!displayValue) {
                this.tagS = ''
                this.autocompleteItemsLoc = []
                this.valueS = []
                this.value = []
                this.valueTag = []
                this.actions = []
                return
            }

            const selectedProvider = this.autocompleteItemslst.find(provider => {
                const label = String(provider.idn_sitename || provider.idn || '').trim().toLowerCase()
                return label === String(displayValue).trim().toLowerCase()
            })

            this.tagS = selectedProvider ? selectedProvider.idn_sitename : ''
        },
        fetchProviderNameList() {
            return recallServices.getProviderNamesForPaperResponse(this.$parent.communicationId).then((res) => {
                this.providerDetails = res.data.d || []
                this.autocompleteItemslst = this.providerDetails
            })
        },
        fetchLocationList() {
            recallServices.getLocationForPaperResponse(this.$parent.communicationId).then((res) => {
                this.autocompleteItemsLocByIDN = []
                this.locationList = []
                for (let i = 0; i < res.data.d.length; i++) {
                    this.autocompleteItemsLocByIDN.push(res.data.d[i])
                    this.locationList.push({
                        isSelected: false,
                        status: 'ACTIVE',
                        text: res.data.d[i].location_name,
                        value: res.data.d[i].id,
                        idn: res.data.d[i].idn,
                        providerOrgId: res.data.d[i].providerOrgId,
                        coveredStatus: res.data.d[i].coveredStatus,
                        siteName: res.data.d[i].siteName,
                    })
                }

                this.setLocations()
                if (this.tagS) {
                    this.applyProviderLocationSelectionRules(this.tagS)
                }
            })
        },
        fetchLocationListForEdit() {
            return recallServices.getLocationForEditPaperResponse(this.$parent.communicationId,this.item.paperresponseid).then((res) => {
                this.locationList = []
                this.autocompleteItemsEditLocByIDN = []
                for (let i = 0; i < res.data.d.length; i++) {
                    this.autocompleteItemsEditLocByIDN.push(res.data.d[i])
                    this.locationList.push({
                        isSelected: false,
                        status: 'ACTIVE',
                        text: res.data.d[i].location_name,
                        value: res.data.d[i].id,
                        idn: res.data.d[i].idn,
                        providerOrgId: res.data.d[i].providerOrgId,
                        coveredStatus: res.data.d[i].coveredStatus,
                        siteName: res.data.d[i].siteName
                    })
                }
                this.setLocations()
            })
        },
        applyProviderLocationSelectionRules(providerIdn) {
            this.setLocations()

            const provider = this.autocompleteItemslst.find(item => item.idn_sitename == providerIdn)
            const coveredStatus = this.normalizeCoveredStatus(provider?.coveredstatus || provider?.coveredStatus || '')
            const shouldAutoSelectAllLocations = this.formType === 'INSERT' && this.isCoveredOrEmailedStatus(coveredStatus)
            this.isLocationLockedByCoveredStatus = shouldAutoSelectAllLocations
            if (!shouldAutoSelectAllLocations) {
                return
            }

            // Fallback to direct provider/location filtering in case setLocations ran before data was fully ready.
            const coveredOrEmailedLocations = this.locationList.filter(location => {
                return location.idn == providerIdn && this.isCoveredOrEmailedStatus(location.coveredStatus)
            })

            if (coveredOrEmailedLocations.length > 0) {
                this.locationListFiltered = coveredOrEmailedLocations
            }

            const selectedLocationIds = this.locationListFiltered.map(location => location.value)
            this.locationObj = selectedLocationIds
            this.addCheck(selectedLocationIds)
        },
        normalizeCoveredStatus(status) {
            return String(status || '').trim().toUpperCase().replace(/-/g, '_').replace(/\s+/g, '_')
        },
        isCoveredOrEmailedStatus(status) {
            const normalized = this.normalizeCoveredStatus(status)
            return normalized === 'COVERED' || normalized === 'EMAILED'
        },
        isNonCoveredStatus(status) {
            return this.normalizeCoveredStatus(status) === 'NON_COVERED'
        },
        getSelectedProvider() {
            return this.autocompleteItemslst.find(provider => {
                return provider.idn_sitename == this.tagS || provider.idn == this.tagS
            }) || null
        },
        getSelectedProviderCoveredStatus() {
            const selectedProvider = this.getSelectedProvider()
            return this.normalizeCoveredStatus(selectedProvider?.coveredstatus || selectedProvider?.coveredStatus || '')
        },
        getSelectedProviderIDN() {
            const selectedProvider = this.getSelectedProvider()
            if (selectedProvider && selectedProvider.idn_sitename) {
                return selectedProvider.idn_sitename
            }
            if ((this.formType == 'EDIT' || this.formType == 'VIEW') && this.item.providerName) {
                return this.item.providerName
            }
            return ''
        },
        async removeDocument(index) {
            this.filesUpload.splice(index, 1)
            this.thumbnailIndex = this.filesUpload.findIndex(x => x.is_thumbnail === true)
        },
        async handleFilesUpload() {
            let uploadedFiles = this.$refs.files1.files
            for (let i = 0; i < uploadedFiles.length; i++) {
                if (uploadedFiles[i].size == 0) {
                    this._showToast('Documented failed to upload. Please try again.', { variant: 'danger' })
                }
                else {
                    this.filesUpload.push({
                        file: uploadedFiles[i],
                        name: uploadedFiles[i].name,
                        type: uploadedFiles[i].type,
                        size: uploadedFiles[i].size,
                    })
                }
            }
            this.$refs.files1.value = ''
        },
        showModal() {
            this.$refs.modal.show()
        },
        async createRecall(e) {
            var isValid = await this.$refs['observer'].validate()
            if (isValid) {
                if (this.formType === 'EDIT') {
                    if (isViewOnlyStatus(this.originalStatus)) {
                        this._showToast('Completed responses cannot be edited.', { variant: 'warning' })
                        return
                    }
                    const transitionError = validateEditStatusTransition(this.originalStatus, this.item.status)
                    if (transitionError) {
                        this._showToast(transitionError, { variant: 'warning' })
                        return
                    }
                }
                if (this.formType === 'INSERT' && this.selectedLocationResponseStatus) {
                    const insertTransitionError = validateEditStatusTransition(
                        this.selectedLocationResponseStatus,
                        this.item.status
                    )
                    if (insertTransitionError) {
                        this._showToast(insertTransitionError, { variant: 'warning' })
                        return
                    }
                }
                this.updateActionResponseFlag()
                const hasActionChangesForStatusValidation = this.formType === 'EDIT'
                    ? this.hasActionResponseChanges()
                    : this.hasAddedActionResponse
                if (this.isNotAcknowledgedStatus(this.item.status) && hasActionChangesForStatusValidation) {
                    this._showToast('You need to change the Response Status either to "In-Progress" or to "Complete" in order to save changes to actions"', { variant: 'warning' })
                    return
                }
                var act = this.actions
                if (act) {
                    for (let i = 0; i < this.actions.length; i++) {
                        if (act[i].action_type == 'MultipleChoice') {
                            if (act[i].multiSelectedValues == null && (act[i].singleSelectedValues == null || act[i].singleSelectedValues == 0)) {
                                this.actions[i].singleSelectedValues = 0
                            }
                            else if (act[i].multiSelectedValues?.length == 0 && (act[i].singleSelectedValues == null || act[i].singleSelectedValues == 0)) {
                                this.actions[i].singleSelectedValues = 0
                            }
                        }
                    }
                }
                let formData = new FormData()
                var actionDoc = this.$refs.actionModal
                var cnt = 0
                if (this.formType == 'INSERT') {
                    for (let i = 0; i < actionDoc.length; i++) {
                        if (this.$refs.actionModal[i].filesUpload.length > 0) {
                            this.$refs.actionModal[i].filesUpload.forEach((x, j) => {
                                formData.append('actiondocument', x.file)
                                formData.append('actionsfiles[' + cnt + '].filename', x.name)
                                formData.append('actionsfiles[' + cnt + '].actionId', x.actionId)
                                cnt++
                            })
                        }
                    }
                }
                else {
                    for (let i = 0; i < actionDoc.length; i++) {
                        if (this.$refs.actionModal[i].type == 'Image' || this.$refs.actionModal[i].type == 'Document') {
                            if (this.$refs.actionModal[i].type == 'Image') {
                                if (this.$refs.actionModal[i].value.valueImage != undefined) {
                                    if (this.$refs.actionModal[i].value.valueImage.length > 0) {
                                        this.$refs.actionModal[i].value.valueImage.forEach((x, j) => {
                                            if (x.id == 0) {
                                                formData.append('actiondocument', x.file)
                                                formData.append('actionsfiles[' + cnt + '].filename', x.name)
                                                formData.append('actionsfiles[' + cnt + '].actionId', x.actionId)
                                                cnt++
                                            }
                                            else {
                                                formData.append('fileids', x.id)
                                            }
                                        })
                                    }
                                }
                            }
                            else if (this.$refs.actionModal[i].type == 'Document') {
                                if (this.$refs.actionModal[i].value.valueDocument != undefined) {
                                    if (this.$refs.actionModal[i].value.valueDocument.length > 0) {
                                        this.$refs.actionModal[i].value.valueDocument.forEach((x, j) => {
                                            if (x.id == 0) {
                                                formData.append('actiondocument', x.file)
                                                formData.append('actionsfiles[' + cnt + '].filename', x.name)
                                                formData.append('actionsfiles[' + cnt + '].actionId', x.actionId)
                                                cnt++
                                            }
                                            else {
                                                formData.append('fileids', x.id)
                                            }
                                        })
                                    }
                                }
                            }
                        }
                    }
                }
                formData.append('paperresponseid', this.item.paperresponseid == null ? 0 : this.item.paperresponseid)
                formData.append('communicationId', this.$parent.communicationId)
                formData.append('responder', this.item.responder)
                formData.append('responsetype', this.selectedResponseType)
                formData.append('responsedate', this.getResponseDateForSave())
                formData.append('notes', this.item.notes ?? '')
                formData.append('emailAddressOption', this.item.emailRadioOption ?? 'central-intake')
                formData.append('responseStatus', this.item.status ?? '')
                if (this.formType == 'INSERT') {
                    formData.append('locationResponseStatus', this.selectedLocationResponseStatus || this.item.status || '')
                }
                if (this.formType == 'INSERT') {
                    this.filesUpload.forEach((x, i) => {
                        if (!x.id) {
                            formData.append('document', x.file)
                        }
                    })
                }
                else {
                    this.filesUpload.forEach((x, i) => {
                        if (x.file != undefined) {
                            formData.append('document', x.file)
                        }
                        else {
                            formData.append('actualfiles[' + i + '].fileid', x.file_id)
                            formData.append('actualfiles[' + i + '].filename', x.name)
                            formData.append('actualfiles[' + i + '].paperresponseid', x.paper_response_id)
                            formData.append('actualfiles[' + i + '].path', x.path)
                            formData.append('actualfiles[' + i + '].extension', x.extension)
                            formData.append('actualfiles[' + i + '].mimetype', x.type)
                            formData.append('actualfiles[' + i + '].signedurl', x.signed_url)
                        }
                    })
                    this.filesUploadOriginal.forEach((x, i) => {
                        formData.append('files[' + i + '].fileid', x.file_id)
                        formData.append('files[' + i + '].filename', x.name)
                        formData.append('files[' + i + '].paperresponseid', x.paper_response_id)
                        formData.append('files[' + i + '].path', x.path)
                        formData.append('files[' + i + '].extension', x.extension)
                        formData.append('files[' + i + '].mimetype', x.type)
                        formData.append('files[' + i + '].signedurl', x.signed_url)
                    })
                }
                formData.append('actions', JSON.stringify(this.actions))
                formData.append('idn', this.tagS)

                const selectedLocationIds = Array.isArray(this.locationObj)
                    ? this.locationObj.filter(x => x && x != 0)
                    : (this.locationObj && this.locationObj != 0 ? [this.locationObj] : [])
                selectedLocationIds.forEach(locationId => {
                    formData.append('location', locationId)
                })
                const selectedLocationProviderOrgIds = this.locationList.find(x => x.value == selectedLocationIds[0])
                const selectedProvider = this.autocompleteItemslst.find(x => x.idn == this.tagS)
                const selectedProviderCoveredStatus = selectedProvider
                    ? (selectedProvider.coveredstatus || selectedProvider.coveredStatus || '')
                    : ''
                formData.append('providerOrgId', selectedLocationProviderOrgIds ? selectedLocationProviderOrgIds.providerOrgId : '')
                formData.append('locationcoveredstatus', selectedLocationProviderOrgIds ? selectedLocationProviderOrgIds.coveredStatus : '')
                formData.append('idncoveredstatus', selectedProviderCoveredStatus)
                if (this.formType == 'INSERT') {
                    recallServices.createPaperResponse(formData).then(async resp => {
                        if (!resp.error) {
                            await this.updateCentralizedSettingIfNeeded()
                            this.$parent.fetchDataOnSuccess('Response created successfully')
                            this.$refs.modal.hide()
                        }
                    })
                }
                else {
                    recallServices.updatePaperResponse(formData).then(async resp => {
                        if (!resp.error) {
                            await this.updateCentralizedSettingIfNeeded()
                            this.$parent.fetchDataOnSuccess('Response updated successfully')
                            this.$refs.modal.hide()
                        } else {
                            const errorMessage = resp.msg || resp.errorMsg || 'Error updating response'
                            this._showToast(errorMessage, { variant: 'danger' })
                        }
                    })
                }
            }
        },
        setLocations() {
            this.locationObj = []
            this.locationListFiltered = []
            this.item.emailAddress = null
            const pushUniqueLocation = (location) => {
                if (!location) {
                    return
                }
                if (!this.locationListFiltered.some(x => x.value == location.value)) {
                    this.locationListFiltered.push(location)
                }
            }
            const selectedProviderCoveredStatus = this.getSelectedProviderCoveredStatus()
            const selectedNames = this.valueTag.map(x => (x || '').trim()).filter(x => x)
            const normalizeLocationText = (text) => {
                const trimmed = (text || '').trim().toLowerCase()
                if (!trimmed) {
                    return ''
                }

                const delimiterIndex = trimmed.indexOf('-')
                return delimiterIndex > -1 ? trimmed.slice(delimiterIndex + 1).trim() : trimmed
            }
            const selectedNamesNormalized = selectedNames.map(normalizeLocationText).filter(x => x)
            const selectedLocationIds = []
            const selectedProviderIDN = this.getSelectedProviderIDN()
            for (let x = 0; x < this.locationList.length; x++) {
                this.locationList[x].isSelected = false
                const locationidnSiteName = this.locationList[x].siteName
                    ? `${this.locationList[x].idn}-${this.locationList[x].siteName}`
                    : this.locationList[x].idn
                if (locationidnSiteName == selectedProviderIDN && (this.formType == 'INSERT')) {
                    const locationCoveredStatus = this.normalizeCoveredStatus(this.locationList[x].coveredStatus)
                    if (this.isCoveredOrEmailedStatus(selectedProviderCoveredStatus)) {
                        if (locationCoveredStatus === 'COVERED' || locationCoveredStatus === 'EMAILED') {
                            pushUniqueLocation(this.locationList[x])
                        }
                    } else if (this.isNonCoveredStatus(selectedProviderCoveredStatus)) {
                        if (locationCoveredStatus === 'NON_COVERED') {
                            pushUniqueLocation(this.locationList[x])
                        }
                    } else {
                        pushUniqueLocation(this.locationList[x])
                    }
                }
                if (locationidnSiteName == selectedProviderIDN && (this.formType == 'EDIT')) {
                    const locationCoveredStatus = this.normalizeCoveredStatus(this.locationList[x].coveredStatus)
                    if (this.isCoveredOrEmailedStatus(selectedProviderCoveredStatus)) {
                        if (locationCoveredStatus === 'COVERED' || locationCoveredStatus === 'EMAILED') {
                            pushUniqueLocation(this.locationList[x])
                        }
                    } else if (this.isNonCoveredStatus(selectedProviderCoveredStatus)) {
                        if (locationCoveredStatus === 'NON_COVERED') {
                            pushUniqueLocation(this.locationList[x])
                        }
                    }
                    else if (!this.selectedLocations.includes(this.locationList[x].text) || this.valueTag.includes(this.locationList[x].text)) {
                        pushUniqueLocation(this.locationList[x])
                    }

                }
                if (selectedNames.length > 0) {
                    const locationText = (this.locationList[x].text || '').trim()
                    const locationTextNormalized = normalizeLocationText(locationText)
                    if (selectedNames.includes(locationText) || selectedNamesNormalized.includes(locationTextNormalized)) {
                        if (this.formType == 'VIEW' || this.formType == 'EDIT') {
                            pushUniqueLocation(this.locationList[x])
                        }
                        if (!selectedLocationIds.includes(this.locationList[x].value)) {
                            selectedLocationIds.push(this.locationList[x].value)
                        }
                        this.locationList[x].isSelected = true
                    }
                }
            }

            if (this.formType == 'INSERT' && this.isCoveredOrEmailedStatus(selectedProviderCoveredStatus)) {
                this.locationListFiltered.forEach((location) => {
                    if (!selectedLocationIds.includes(location.value)) {
                        selectedLocationIds.push(location.value)
                    }
                    location.isSelected = true
                })
            }

            if (selectedLocationIds.length === 0 && this.formType == 'EDIT' && this.locName) {
                const normalizedLocName = normalizeLocationText(this.locName)
                const selectedLocationByLocName = this.locationList.find((location) => {
                    const locationIdnSiteName = location.siteName
                        ? `${location.idn}-${location.siteName}`
                        : location.idn
                    if (locationIdnSiteName != this.getSelectedProviderIDN()) {
                        return false
                    }

                    const locationText = (location.text || '').trim()
                    return locationText == (this.locName || '').trim() || normalizeLocationText(locationText) == normalizedLocName
                })

                if (selectedLocationByLocName) {
                    selectedLocationIds.push(selectedLocationByLocName.value)
                    selectedLocationByLocName.isSelected = true

                    if (!this.locationListFiltered.some(location => location.value == selectedLocationByLocName.value)) {
                        this.locationListFiltered.push(selectedLocationByLocName)
                    }
                }
            }
            this.locationObj = selectedLocationIds
        },
        responseDateEdit() {
            // var dateSubtract = moment()
            // dateSubtract = dateSubtract.subtract(-1,'DD')
            // alert('date: '+ moment(this.item.responseDate).format('YYYY/MM/DD'))
            this.responseDate = new Date()
        },
        onResponseDateSelected() {
            this.responseDateUserEdited = true
        },
        toApiResponseDate(value) {
            if (!value) {
                return ''
            }
            const utcDate = moment.utc(value)
            return utcDate.isValid() ? utcDate.format('YYYY/MM/DD') : ''
        },
        parseResponseDate(value) {
            if (!value) {
                return null
            }
            const utcDate = moment.utc(value)
            return utcDate.isValid()
                ? new Date(utcDate.year(), utcDate.month(), utcDate.date())
                : null
        },
        formatResponseDate(value) {
            if (!value) {
                return ''
            }
            if (value instanceof Date) {
                const month = String(value.getMonth() + 1).padStart(2, '0')
                const day = String(value.getDate()).padStart(2, '0')
                return `${value.getFullYear()}/${month}/${day}`
            }
            return this.toApiResponseDate(value)
        },
        getResponseDateForSave() {
            if (this.formType === 'EDIT' && !this.responseDateUserEdited && this.originalResponseDateForSave) {
                return this.originalResponseDateForSave
            }
            return this.formatResponseDate(this.item.responseDate)
        },
        getProviderResponseHistory(paperResponseId) {
            recallServices.providerResponseChangeHistory(this.$parent.communicationId, paperResponseId).then(resp => {
                if (!resp.error) {
                    this.histories = resp.data.d || []
                }
            })
        },
        applySupplierDataToActions() {
            if (!this.actions || !this.supplierActionResponseAndStatus) return
            const supplierActions = this.supplierActionResponseAndStatus.actions || []
            if (!supplierActions.length) return

            this.actions.forEach(action => {
                const supplierAction = supplierActions.find(sa => sa.action_id == action.id)
                if (!supplierAction || !supplierAction.data) return

                const data = supplierAction.data

                if (action.action_type === 'MultipleChoice') {
                    if (!action.isAllowOnlyOne) {
                        action.multiSelectedValues = []
                        if (data.valueMultiChoice && Array.isArray(data.valueMultiChoice)) {
                            data.valueMultiChoice.forEach(choice => {
                                const matchingOption = action.actionValues.find(av => av.text === choice.valueMultiChoice)
                                if (matchingOption) {
                                    action.multiSelectedValues.push(matchingOption.value)
                                }
                            })
                        }
                    } else {
                        const singleVal = data.valueSingleChoice ||
                            (data.valueMultiChoice && data.valueMultiChoice.length > 0
                                ? data.valueMultiChoice[0].valueMultiChoice
                                : null)
                        if (singleVal) {
                            const matchingOption = action.actionValues.find(av => av.text === singleVal)
                            if (matchingOption) {
                                action.singleSelectedValues = matchingOption.value
                            }
                        }
                    }
                } else {
                    action.response_data = Object.assign({}, action.response_data, data)
                }
            })
            this.actions = [...this.actions]
        },
        getSupplierActionResponseAndStatus(providerOrganizationId, locationId){
            recallServices.getSupplierActionResponseAndStatus(this.$parent.communicationId, providerOrganizationId, locationId).then(resp => {
                if (!resp.error) {
                    this.supplierActionResponseAndStatus = resp.data.d || null
                    this.item.status = this.supplierActionResponseAndStatus.status || this.item.status
                    this.selectedLocationResponseStatus = this.item.status || null
                    this.applySupplierDataToActions()
                }
            })
        },
        isNotAcknowledgedStatus(status) {
            const normalized = String(status || '').toLowerCase().replace(/[^a-z]/g, '')
            return normalized === 'notacknowledged' || normalized === 'notacknowledge'
        },
        hasValue(value) {
            if (Array.isArray(value)) {
                return value.length > 0
            }
            if (typeof value === 'string') {
                return value.trim().length > 0
            }
            if (typeof value === 'number') {
                return !Number.isNaN(value)
            }
            if (typeof value === 'boolean') {
                return true
            }
            return value != null
        },
        hasActionResponse(action) {
            if (!action) {
                return false
            }

            if (action.action_type === 'MultipleChoice') {
                const hasSingleChoice = action.singleSelectedValues != null && action.singleSelectedValues !== 0
                const hasMultiChoice = Array.isArray(action.multiSelectedValues) && action.multiSelectedValues.length > 0
                return hasSingleChoice || hasMultiChoice
            }

            const responseData = action.response_data || {}
            return [
                responseData.valueAcknowledge,
                responseData.valueText,
                responseData.valueNumeric,
                responseData.valueYesNo,
                responseData.valueCheckbox,
                responseData.valueSingleChoice,
                responseData.valueMultiChoice,
                responseData.valueImage,
                responseData.valueDocument,
            ].some(value => this.hasValue(value))
        },
        getActionResponseSnapshot(action) {
            if (!action) {
                return null
            }

            const baseSnapshot = {
                id: action.id,
                actionType: action.action_type,
            }

            if (action.action_type === 'MultipleChoice') {
                const multi = Array.isArray(action.multiSelectedValues)
                    ? [...action.multiSelectedValues].sort((a, b) => a - b)
                    : []
                return {
                    ...baseSnapshot,
                    singleSelectedValues: action.singleSelectedValues ?? null,
                    multiSelectedValues: multi,
                }
            }

            return {
                ...baseSnapshot,
                responseData: _.cloneDeep(action.response_data || {}),
            }
        },
        getActionsSnapshot(actions) {
            const actionList = Array.isArray(actions) ? actions : []
            return actionList
                .map(action => this.getActionResponseSnapshot(action))
                .filter(Boolean)
                .sort((a, b) => {
                    if (a.id == null && b.id == null) return 0
                    if (a.id == null) return 1
                    if (b.id == null) return -1
                    return a.id - b.id
                })
        },
        setInitialActionResponses() {
            this.initialActionResponses = this.getActionsSnapshot(this.actions)
        },
        hasActionResponseChanges() {
            const initialSnapshot = Array.isArray(this.initialActionResponses)
                ? this.initialActionResponses
                : []
            const currentSnapshot = this.getActionsSnapshot(this.actions)
            return !_.isEqual(initialSnapshot, currentSnapshot)
        },
        updateActionResponseFlag() {
            this.hasAddedActionResponse = Array.isArray(this.actions)
                ? this.actions.some(action => this.hasActionResponse(action))
                : false
        }
    }
}